var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercentageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM8.28225 9.22708C9.05948 9.67581 10.0533 9.40951 10.502 8.63229C10.9508 7.85506 10.6845 6.86123 9.90725 6.41249C9.13003 5.96376 8.13619 6.23006 7.68746 7.00729C7.23873 7.78451 7.50503 8.77835 8.28225 9.22708ZM14.1928 6.99993C13.8101 6.77902 13.3209 6.91012 13.0999 7.29275L8.39994 15.4334C8.17903 15.816 8.31013 16.3053 8.69276 16.5262L9.47218 16.9762C9.85482 17.1971 10.3441 17.066 10.565 16.6834L15.265 8.54275C15.4859 8.16012 15.3548 7.67085 14.9722 7.44993L14.1928 6.99993ZM16.3021 16.9653C15.8534 17.7426 14.8595 18.0089 14.0823 17.5601C13.3051 17.1114 13.0388 16.1176 13.4875 15.3403C13.9362 14.5631 14.9301 14.2968 15.7073 14.7455C16.4845 15.1943 16.7508 16.1881 16.3021 16.9653Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentageIcon);
export default __webpack_public_path__ + "static/media/Percentage Icon.dadf54e18816944ab765fc6ebf8ef7f9.svg";
export { ForwardRef as ReactComponent };